import cn from 'classnames';
import { format, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import type { ComponentProps } from 'react';
import * as st from './styles.module.scss';

type DateVariant = 'brief' | 'withMonth';

const getFormat = (variant: DateVariant) => {
  if (variant === 'withMonth') {
    return 'dd MMMM yyyy';
  }
  return 'dd.MM.yyyy';
};

type PT = ComponentProps<'p'> & {
  variant?: 'primary' | 'secondary';
  dateVariant?: DateVariant;
  value: string;
};
/**
 * DateViewer
 * @param className
 * @param children
 * @param value
 * @param variant
 * @param dateVariant - brief = '1.1.2001' withMonth = '1 января 2001'
 * @param props
 * @constructor
 */

export const DateViewer = ({
  className,
  children,
  value,
  variant = 'secondary',
  dateVariant = 'brief',
  ...props
}: PT) => {
  const date = parseISO(value);
  const formattedDate = format(date, getFormat(dateVariant), { locale: ru });

  return (
    <p className={cn(st[variant], className)} {...props}>
      {formattedDate}
      {children}
    </p>
  );
};
